import React, { Component, PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import moment from 'moment'
import { trackPromise } from 'react-promise-tracker'
import cookie from 'react-cookies'

import FilterMealsScreen from './FilterMealsScreen.tsx'
import { getUserDailyBalance } from '../../../Api/dietApi/userInfo'

class FilterMealsScrenContainer extends Component {
  state = {
    kcalFilter: cookie.load('kcalFilter') ? cookie.load('kcalFilter') : {},
    mealTypeFilter: cookie.load('mealTypeFilter')
      ? cookie.load('mealTypeFilter')
      : [],
    chosenDate: this.props.match.params.chosenDate,
    isDemoAccount: cookie.load('userDemoMode'),
  }

  componentDidMount = () => {
    this.getUserDiet()
    this.setStartFilters()
  }

  getUserDiet = async () => {
    const userBalance = await trackPromise(
      getUserDailyBalance(moment().format('YYYY-MM-DD'))
    )

    if (userBalance) {
      this.setState({
        diet: userBalance.diet,
      })
    }
  }

  filterMealType = (filter) => {
    if (
      !this.state.mealTypeFilter.filter((e) => e.id === filter.id).length > 0
    ) {
      this.setState({
        mealTypeFilter: [...this.state.mealTypeFilter, filter],
      })
    } else {
      const mealFilters = this.state.mealTypeFilter
      let filtered = mealFilters.filter((meal) => meal.id !== filter.id)
      this.setState({
        mealTypeFilter: filtered,
      })
    }

    setTimeout(() => {
      if (this.state.mealTypeFilter.length == 0) {
        cookie.remove('mealTypeFilter')
        cookie.remove('userResettedFiltersOnMainPage')
      } else {
        cookie.save('mealTypeFilter', JSON.stringify(this.state.mealTypeFilter))
        cookie.remove('userResettedFiltersOnMainPage')
      }
    }, 150)
  }

  filterKcal = (filter) => {
    if (this.state.kcalFilter.id !== filter.id) {
      this.setState({
        kcalFilter: filter,
      })
    } else {
      this.setState({
        kcalFilter: {},
      })
    }

    setTimeout(() => {
      cookie.save('kcalFilter', JSON.stringify(this.state.kcalFilter))
      cookie.remove('userResettedFiltersOnMainPage')
    }, 150)
  }

  setStartFilters = () => {
    const mealTypeFilters = [
      { text: 'ŚNIADANIA', value: 'Śniadanie', id: 0 },
      { text: 'II ŚNIADANIA', value: 'II śniadanie', id: 1 },
      { text: 'OBIADY', value: 'Obiad', id: 2 },
      { text: 'KOALCJE', value: 'Kolacja', id: 3 },
      { text: 'PRZEKĄSKA', value: 'Przekąska', id: 4 },
    ]
    // const weightFilters = [
    //   { text: '50 - 200 kcal', valMin: 50, valMax: 199, id: 0 },
    //   { text: '200 - 300 kcal', valMin: 200, valMax: 299, id: 1 },
    //   { text: '300 - 400 kcal', valMin: 300, valMax: 399, id: 2 },
    //   { text: '400 - 500 kcal', valMin: 400, valMax: 499, id: 3 },
    //   { text: 'powyżej 500 kcal', valMin: 500, valMax: 100000000, id: 4 },
    // ]

    if (
      this.props.location.chosedMealType &&
      !this.props.location.mealTypeFilters &&
      !cookie.load('mealTypeFilter') &&
      !cookie.load('kcalFilter')
    ) {
      const chosenType = mealTypeFilters.filter(
        (meal) => meal.value == this.props.location.chosedMealType
      )

      this.setState({
        mealTypeFilter: chosenType,
      })
      cookie.save('mealTypeFilter', JSON.stringify(chosenType))

      let saved = JSON.stringify(chosenType)
    } else {
      if (
        this.props.location.mealTypeFilters ||
        cookie.load('mealTypeFilter') ||
        cookie.load('kcalFilter')
      ) {
        if (this.props.location.mealTypeFilters) {
          this.setState({
            mealTypeFilter: this.props.location.mealTypeFilters,
          })
        } else if (cookie.load('mealTypeFilter') || cookie.load('kcalFilter')) {
          if (cookie.load('mealTypeFilter')) {
            let mealFIlters = cookie.load('mealTypeFilter')
            this.setState({
              mealTypeFilter: mealFIlters,
            })
          }
          if (cookie.load('kcalFilter')) {
            let kcalFilter = cookie.load('kcalFilter')
            this.setState({
              kcalFilter: kcalFilter,
            })
          }
        }
      }
    }
  }

  checkSetFilters = () => {}

  renderFilteredItems = () => {
    let properMealTypeName

    switch (this.props.location.chosedMealType) {
      case 'Śniadanie':
        properMealTypeName = 'sniadanie'
        break
      case 'II śniadanie':
        properMealTypeName = 'IIsniadanie'
        break
      case 'Obiad':
        properMealTypeName = 'obiad'
        break
      case 'Kolacja':
        properMealTypeName = 'kolacja'
        break
      case 'Przekąska':
        properMealTypeName = 'przekaska'
        break
    }
    if (
      this.state.mealTypeFilter.length == 0 &&
      Object.keys(this.state.kcalFilter).length === 0
    ) {
      this.props.history.push({
        pathname: `/dieta/${properMealTypeName}/${this.state.chosenDate}/gotowe-posilki/`,
        chosedMealType: this.props.location.chosedMealType,
      })
    } else {
      this.props.history.push({
        pathname: `/dieta/${properMealTypeName}/${this.state.chosenDate}/gotowe-posilki/`,
        chosedMealType: this.props.location.chosedMealType,
      })
    }
  }

  clearFilters = () => {
    if (cookie.load('mealTypeFilter') || cookie.load('kcalFilter')) {
      cookie.remove('mealTypeFilter')
      cookie.remove('kcalFilter')
    }

    this.setState({
      kcalFilter: {},
      mealTypeFilter: [],
    })
    setTimeout(() => {
      window.location.reload()
    }, 50)
  }

  checkIfFilterIsChecked = (mode, filter) => {
    let isChecked = false
    if (mode == 'kcal') {
      filter.id == this.state.kcalFilter.id
        ? (isChecked = true)
        : (isChecked = false)
    } else {
      this.state.mealTypeFilter.forEach((mealType) => {
        if (mealType.id == filter.id) {
          isChecked = true
        }
      })
    }
    return isChecked
  }

  render() {
    return (
      <FilterMealsScreen
        filterMealType={this.filterMealType}
        filterKcal={this.filterKcal}
        renderFilteredItems={this.renderFilteredItems}
        chosenMealTypeFilters={this.state.mealTypeFilter}
        chosenKcalFilters={this.state.kcalFilter}
        checkIfFilterIsChecked={this.checkIfFilterIsChecked}
        clearFilters={this.clearFilters}
        diet={this.state.diet}
        isDemoAccount={this.state.isDemoAccount}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    diet: state.diet,
  }
}

// function mapDispatchToProps(dispatch) {
//   return {
//     dietActions: bindActionCreators(dietActions, dispatch),
//   }
// }

export default compose(
  withRouter,
  connect(mapStateToProps)
)(FilterMealsScrenContainer)
